import {createUseStyles} from 'react-jss';
import Spacing from '../../../../v2/style-helper/Spacing';
import Typography from '../../../../v2/style-helper/Typography';

export default createUseStyles({
  socialChannelButton: props => ({
    fontFamily: 'Helvetica Neue, helvetica, arial, serif',
    fontSize: (props.isUsingArtemisStyles && props.theme.typography?.[Typography.small]?.largeDevice?.fontSize)
      ? props.theme.typography[Typography.small].largeDevice.fontSize : 14,
    fontWeight: 'normal',
    position: 'relative',
    display: 'inline-block',
    width: '48%',
    minWidth: 175,
    margin: [0, 2, 10],
    padding: 10,
    textAlign: 'left',
    textDecoration: 'none',
    color: '#fff',
    border: '1px solid #dededf',
    borderRadius: 2,
    textShadow: 'none',
    
    ...(props.channelName === 'facebook') && ({
      background: '#3a5798',
    }),
    
    ...(props.channelName === 'messenger') && ({
      background: '#fff',
      color: '#0080ff',
    }),
  
    ...(props.channelName === 'email') && ({
      background: '#817d7e',
    }),
    
    ...(props.channelName === 'twitter') && ({
      background: '#00aaed',
    }),
  
    ...(props.channelName === 'vk') && ({
      background: '#6383a8',
    }),
  
    ...(props.channelName === 'weibo') && ({
      color: '#ea602b',
      background: '#fff',
    }),
  
    ...(props.channelName === 'whatsapp') && ({
      background: '#43d854',
    }),
  
    ...(props.channelName === 'sms') && ({
      color: '#777',
      background: '#fff',
    }),
  
    ...(props.channelName === 'copyLink') && ({
      color: '#555',
      background: '#fff',
      borderColor: props.theme.core.brand,
    }),
    
  }),
  
  icon: {
    margin: 'auto',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: Spacing.single,
  },
  
  text: {
    marginLeft: 30,
  },
});
